<template>
  <div class="prompt-content">
    <h3 class="title">报表类型说明</h3>
    <table class="prompt-table">
      <tr>
        <th style="width: 50%">类型</th>
        <th style="width: 50%">中文释义</th>
      </tr>
      <tr v-for="item in prompt" :key="item.type">
        <td>{{ item.type }}</td>
        <td>{{ item.name }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
const promptOptions = {
  us: [
    {
      type: 'FY',
      name: '年报'
    },
    {
      type: 'Q4',
      name: '四季报(单季)'
    },
    {
      type: 'Q9',
      name: '三季报(累计)'
    },
    {
      type: 'Q3',
      name: '三季报(单季)'
    },
    {
      type: 'Q6',
      name: '二季报(累计)'
    },
    {
      type: 'Q2',
      name: '二季报(单季)'
    },
    {
      type: 'Q1',
      name: '一季报'
    }
  ],
  hk: [
    {
      type: 'F',
      name: '年报'
    },
    {
      type: 'Q3',
      name: '三季报'
    },
    {
      type: 'I',
      name: '中报'
    },
    {
      type: 'Q1',
      name: '一季报'
    }
  ]
}
export default {
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    prompt() {
      return promptOptions[this.market]
    }
  }
}
</script>

<style lang="scss" scoped>
.prompt-content {
  .prompt-table {
    width: 100%;
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    margin-top: 20px;
    th,
    td {
      border-width: 1px;
      border-style: solid;
      padding: 10px 0;
    }
  }
}
</style>
